import * as React from 'react'
import { Input as InputPrimitive } from '@base-ui/react/input'

import { cn } from '@/components/new/lib/utils'

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<typeof InputPrimitive>>(
    ({ className, type, ...props }, ref) => {
        return (
            <InputPrimitive
                ref={ref}
                type={type}
                data-slot="input"
                className={cn(
                    'border-input bg-background shadow-xs file:text-foreground placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 dark:bg-input/30 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 h-9 w-full min-w-0 rounded-md border px-2.5 py-1 text-base outline-none transition-[color,box-shadow] file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
                    className
                )}
                {...props}
            />
        )
    }
)

Input.displayName = 'Input'

export { Input }
